<section class="instructor-list-wrapper pb-0 pt-small-0">
  <div class="container px-md-0">
    <div class="d-flex flex-row flex-sm-column">
      <div class="responsive-header">{{ translationScope+'.titles.active_instructors' | transloco }}</div>
      <div class="filter-list-container mt-4">
        <app-instructors-filter
          [instructorFilter]="instructorFilter$ | async"
          [templates]="templates$ | async"
          [regions]="regions$ | async"
          [categories]="categories$ | async"
          (changeInstructorFilter)="updateInstructorFilter($event)"
        ></app-instructors-filter>
      </div>
    </div>
  </div>
</section>
<section class="instructor-list">
  <div class="container px-md-0">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-3 py-4"  *ngFor="let instructor of instructors$ | async">
        <app-instructor-preview-card  [instructor]="instructor">
        </app-instructor-preview-card>
      </div>
    </div>
  </div>
</section>
<div
  infiniteScroll
  [infiniteScrollThrottle]="600"
  [infiniteScrollDistance]="2.5"
  [infiniteScrollDisabled]="isAllLoaded$ | async"
  (scrolled)="loadMore()"
></div>
